import { runtime } from '../../Runtime';
import { RuntimeSchedule } from './RuntimeSchedule';
export class RuntimeScheduleNextIdle extends RuntimeSchedule {
    addToNext(actionFunc, options = {}) {
        if (runtime.isServerRuntime) {
            actionFunc();
            return;
        }
        let idleCallbackFunction = window.requestIdleCallback;
        if (typeof idleCallbackFunction !== 'function') {
            idleCallbackFunction = window.requestAnimationFrame;
        }
        const task = this.addTask(actionFunc, options);
        if (!task)
            return;
        idleCallbackFunction(this.processCurrentBatch, options);
        return task.promise;
    }
}
